export enum MonsterType {
  normal = 'normal',
  elite = 'elite',
  boss = 'boss'
}
